export default "__VITE_ASSET__B3i1ScuP__"